<template lang="pug">
	.app.flex-row.align-items-center
		.container.py-3.px-3
			b-row.justify-content-center.no-gutters
				b-col(md='6' sm='8')
					b-card.mb-0(no-body='')
						b-card-body.p-4
							h1 Регистрация
							p.text-muted Создайте свой аккаунт

							Alerts(ref="Alerts")

							b-form(@submit.prevent='onSubmit' v-if="!requestSend")
								component.mb-3(:is="field.widget" v-model='account[field.name]' :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback" v-for='field in userModel' :key='field.name')

								b-row
									b-col(cols='12')
										b-button(variant='success' type='submit' block) Создать аккаунт
									b-col.text-center(cols='12')
										b-button.px-0(variant='link' to="/login") Вернуться к авторизации

					//
						b-card-footer.p-4
						b-row
							b-col(cols='6')
							b-button.btn.btn-facebook(block='')
								span facebook
							b-col(cols='6')
							b-button.btn.btn-twitter(block='' type='button')
								span twitter
</template>

<script>
	import { mapActions, mapState } from 'vuex'

	import userModel from '../store/forms/formAccount'

	import Alerts from './components/Alerts'

	import parseUrlMixin from '../MIXINS/parseUrl';
	import clearFormMixin from '../MIXINS/clearForm';
	import formBackValidationMixin from '../MIXINS/formBackValidation';

	export default {
		name: 'Register',
		components: {Alerts},
		mixins: [
			parseUrlMixin,
			clearFormMixin,
			formBackValidationMixin,
		],
		data: () => ({
			userModel,
			requestSend: false,
			msg: {
				ok: "Регистрация прошла успешно",
				err: null,
			},
		}),
		computed: {
			...mapState(['account','auth']),

			error(){ return this.auth.error }
		},
		methods: {
			...mapActions(['registration']),

			okHandlerAfter(){
				const urlData = this.parseUrl(window.location.search);
				const url = urlData.redirect_url ? decodeURIComponent(urlData.redirect_url): '/';
				setTimeout( () => (window.location.href = url),1000 )
			},
			okHandlerBefore(){
				this.clearForm('form');
				this.requestSend = true;
			},
			async successFormHandler() {

				await this.okHandlerBefore();

				await this.error
					? this.errorFormHandler(this.error)
					: this.$refs.Alerts.showAlert(this.msg.ok, 'success');


				await this.okHandlerAfter();
			},
			errorFormHandler(error) {
				if (!error) {
					this.$refs.Alerts.showAlert('Ошибка при выполнении запроса! Проверьте соединение с интернетом', 'error');
					return false;
				}
				error.non_field_errors
					? this.$refs.Alerts.showAlert(error.non_field_errors[0], 'error')
					: this.$refs.Alerts.showAlert(this.msg.err, 'error');

				this.$refs.Alerts.showAlert(error.non_field_errors || 'Произошла ошибка при выполнении запроса!', 'error')
			},
			onSubmit() {
				this.$store.dispatch('registration', this.account)
					.then( this.successFormHandler )
					.catch( this.errorFormHandler );
			},
		},
	}

</script>
